<template>
  <div>
    <CountStorageHeader :img_header="header_image" header="แก้ไขข้อมูลรอบนับสต๊อก" link_back="stock/count_warehouse/countlistwarehouse"/>
    <Warehouse_edit/>
  </div>
</template>

<script>
import CountStorageHeader from "@/components/admin/stock/count_storage/headercount_storage/CountStorageHeader";
import Warehouse_edit from "@/components/admin/stock/count_storage/Warehouse_edit";
import HeaderImage from "@/assets/checklist.png";
export default {
  name: "WarehouseEdit",
  components: {
    Warehouse_edit,
    CountStorageHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
